import Vue from 'vue'
import Profiel from '../vue/Profiel.vue'

export default {
  init() {
    new Vue({
      el: '#app',
      components: {
        Profiel,
      },
    })
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/profiel.js